import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/leave-type/v1";

export const getLeaveType = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createLeaveType(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getLeaveTypeAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getLeaveTypeDetail(id) {
  return GETDetail(API_URL, id);
}

export function editLeaveType(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archiveLeaveType(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveLeaveType(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteLeaveType(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}